import {Map as MaplibreMap} from 'maplibre-gl'

export const SUN_LIGHT_UPDATE_MS = 5 * 60 * 1000
const SUN_LIGHT_COLOR = '#fff1dc'
const SUN_LIGHT_RADIAL = 1.15
const SUN_INTENSITY_DAY = 0.4
const SUN_INTENSITY_NIGHT = 0.3
const SUN_MIN_ALTITUDE = 8
const SUN_MAX_ALTITUDE = 40
const J2000_MS = 946728000000
const DAY_MS = 86400000

const RAD = Math.PI / 180

export const sunPosition = (date: Date, lat: number, lng: number) => {
  const d = (date.getTime() - J2000_MS) / DAY_MS
  const g = (357.529 + 0.98560028 * d) * RAD
  const L =
    (280.459 + 0.98564736 * d + 1.915 * Math.sin(g) + 0.02 * Math.sin(2 * g)) *
    RAD
  const e = (23.439 - 0.00000036 * d) * RAD
  const ra = Math.atan2(Math.cos(e) * Math.sin(L), Math.cos(L))
  const dec = Math.asin(Math.sin(e) * Math.sin(L))
  const gmst = (18.697374558 + 24.06570982441908 * d) % 24
  const H = (gmst * 15 + lng) * RAD - ra
  const phi = lat * RAD
  const alt = Math.asin(
    Math.sin(phi) * Math.sin(dec) + Math.cos(phi) * Math.cos(dec) * Math.cos(H)
  )
  const az = Math.atan2(
    -Math.sin(H),
    Math.cos(phi) * Math.tan(dec) - Math.sin(phi) * Math.cos(H)
  )
  return {azimuth: (az / RAD + 360) % 360, altitude: alt / RAD}
}

export const updateSunLight = (map: MaplibreMap) => {
  const center = map.getCenter()
  const sun = sunPosition(new Date(), center.lat, center.lng)
  const altitude = Math.min(
    SUN_MAX_ALTITUDE,
    Math.max(SUN_MIN_ALTITUDE, sun.altitude)
  )
  map.setLight({
    anchor: 'map',
    color: SUN_LIGHT_COLOR,
    intensity: sun.altitude > 0 ? SUN_INTENSITY_DAY : SUN_INTENSITY_NIGHT,
    position: [SUN_LIGHT_RADIAL, sun.azimuth, 90 - altitude],
  })
}
